namespace TabAurous.Purchase {
    export namespace OpenConsignmentInDetailedService {
        export const baseUrl = 'Purchase/OpenConsignmentInDetailed';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<Reports.StockBifurcationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PartyList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalInItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Purchase/OpenConsignmentInDetailed/List",
            PartyList = "Purchase/OpenConsignmentInDetailed/PartyList"
        }

        [
            'List', 
            'PartyList'
        ].forEach(x => {
            (<any>OpenConsignmentInDetailedService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
